/**
 * Tiny function to turn `ENUMS_LIKE_THIS` into `Enums like this` for use in the front end.
 * Avoid using this, favour language strings in the `constants.js` file.
 *
 * @function
 * @param    {string} text [description]
 * @returns  {[type]}      [description]
 */
function deEnum(text) {
    return (
        text[0].toUpperCase() +
        text.substring(1).toLowerCase().replace(/_/g, ' ')
    );
}

export { deEnum };
